__turbopack_context__.v({
  "center": "twoColumnTextImageMobile-module-scss-module__HkAVNq__center",
  "contentPadding": "twoColumnTextImageMobile-module-scss-module__HkAVNq__contentPadding",
  "ctaContainer": "twoColumnTextImageMobile-module-scss-module__HkAVNq__ctaContainer",
  "darkBlue": "twoColumnTextImageMobile-module-scss-module__HkAVNq__darkBlue",
  "description": "twoColumnTextImageMobile-module-scss-module__HkAVNq__description",
  "horizontal": "twoColumnTextImageMobile-module-scss-module__HkAVNq__horizontal",
  "icon": "twoColumnTextImageMobile-module-scss-module__HkAVNq__icon",
  "image": "twoColumnTextImageMobile-module-scss-module__HkAVNq__image",
  "imageBelow": "twoColumnTextImageMobile-module-scss-module__HkAVNq__imageBelow",
  "left": "twoColumnTextImageMobile-module-scss-module__HkAVNq__left",
  "mobileLayout": "twoColumnTextImageMobile-module-scss-module__HkAVNq__mobileLayout",
  "mobileView": "twoColumnTextImageMobile-module-scss-module__HkAVNq__mobileView",
  "roundedImage": "twoColumnTextImageMobile-module-scss-module__HkAVNq__roundedImage",
  "secondary": "twoColumnTextImageMobile-module-scss-module__HkAVNq__secondary",
  "subHeader": "twoColumnTextImageMobile-module-scss-module__HkAVNq__subHeader",
  "textUpper": "twoColumnTextImageMobile-module-scss-module__HkAVNq__textUpper",
  "title": "twoColumnTextImageMobile-module-scss-module__HkAVNq__title",
  "vertical": "twoColumnTextImageMobile-module-scss-module__HkAVNq__vertical",
});
